<template>
    <div :style="backUrl ? { backgroundImage: `url(${backUrl})` , backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }  : {}" class="triangle-core-display">
        <!-- 顶部标题，与其他组件标题样式统一 -->
        <div class="top-margin"></div>
        <div v-if="title" class="component-title">{{ title }}</div>

        <!-- 三角形核心组件展示区域：弹性布局，避免绝对定位冲突 -->
        <div style="margin-top: 70px" class="triangle-container">
            <!-- 左侧内容（宽度300px，右对齐贴边） -->
            <div class="triangle-section left-section">
                <h3 class="section-title">{{ triangleData.leftTitle }}</h3>
                <div class="section-content">{{ triangleData.leftContent }}</div>
            </div>

            <!-- 中间三角形与核心标题容器：居中布局 -->
            <div class="middle-container">
                <!-- 多边形背景图（固定210x210px） -->
                <div class="polygon-bg"></div>
                <!-- 中心核心标题（红色，强制换行不溢出） -->
                <div class="core-title">{{ triangleData.coreTitle }}</div>
            </div>

            <!-- 右侧内容（宽度300px，左对齐贴边） -->
            <div class="triangle-section right-section">
                <h3 class="section-title">{{ triangleData.rightTitle }}</h3>
                <div class="section-content">{{ triangleData.rightContent }}</div>
            </div>
        </div>

        <!-- 底部内容（图形正下方，居中） -->
        <div class="triangle-section bottom-section">
            <h3 class="section-title">{{ triangleData.bottomTitle }}</h3>
            <div class="section-content">{{ triangleData.bottomContent }}</div>
        </div>

        <!-- 下方富文本内容：独立区域，避免与其他组件重叠 -->
        <div class="bottom-rich-content" v-html="richContent"></div>
        <div class="top-margin"></div>
    </div>
</template>

<script>
export default {
    name: "TriangleCoreDisplay",
    props: {
        sourceData: {
            type: String,
            required: true,
            default: '{"leftTitle":"","leftContent":"","rightTitle":"","rightContent":"","bottomTitle":"","bottomContent":"","coreTitle":""}@FUWENBEN@'
        },
        title: {
            type: String,
            default: ""
        },
        backUrl:{
            type: String,
            default: ''
        },
        detailUrl:{
            type: String,
            default: ''
        },
    },
    data() {
        return {
            triangleData: {
                leftTitle: "",
                leftContent: "",
                rightTitle: "",
                rightContent: "",
                bottomTitle: "",
                bottomContent: "",
                coreTitle: ""
            },
            richContent: ""
        };
    },
    watch: {
        sourceData: {
            immediate: true,
            handler(newVal) {
                this.parseSourceData(newVal);
            }
        }
    },
    methods: {
        parseSourceData(source) {
            try {
                const [jsonPart, richPart] = source.split("@FUWENBEN@");
                const parsedData = JSON.parse(jsonPart);
                this.triangleData = { ...this.triangleData, ...parsedData };
                this.richContent = richPart || "";
            } catch (error) {
                console.error("解析三角形核心组件数据失败:", error);
            }
        }
    }
};
</script>

<style scoped>
.triangle-core-display {
    width: 100%;
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    /* 防止组件整体与其他元素重叠 */
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 顶部标题样式统一 */
.component-title {
    padding: 16px 20px;
    font-size: 28px;
    font-weight: 500;
    color: #333;
    text-align: center;
    margin-bottom: 0;
}

/* 容器：弹性布局，左右内容+中间三角形横向排列 */
.triangle-container {
    width: 100%;
    /* 适配左右300px+中间210px的宽度需求，留足间距 */
    min-width: 850px;
    max-width: 1200px;
    margin: 0 auto;
    /* 核心：使用弹性布局替代绝对定位 */
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 15px; /* 左右内容与三角形的间距（贴边效果） */
}

/* 中间三角形容器：相对定位（仅内部标题定位用），不影响外部布局 */
.middle-container {
    position: relative;
    width: 210px;
    height: 210px; /* 三角形宽高改为210px */
}

/* 多边形背景图（固定210x210px，居中显示） */
.polygon-bg {
    width: 100%;
    height: 100%;
    background-image: url(./duobianxing.png);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    z-index: 1;
}

/* 中心核心标题（红色，严格限制在210x210px三角形内） */
.core-title {
    position: absolute;
    top: 60%;
    left: 50%;
    /* 居中且不超出三角形 */
    transform: translate(-50%, -50%);
    color: #ed0200;
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    line-height: 1.3;
    z-index: 2;
    /* 关键：强制限制宽度，确保不超出210px三角形 */
    max-width: 180px; /* 小于三角形宽度，留边距 */
    max-height: 180px; /* 小于三角形高度，留边距 */
    /* 强制换行，避免溢出 */
    word-break: break-word;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 内容区域通用样式：宽度提升至300px */
.triangle-section {
    width: 300px; /* 满足至少300px的宽度需求 */
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    /* 与三角形顶部对齐 */
    align-self: flex-start;
}

/* 标题样式统一 */
.section-title {
    font-size: 20px;
    font-weight: 700;
    margin: 0 0 8px 0;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 内容样式统一：自动换行，无高度限制（按需滚动） */
.section-content {
    font-size: 14px;
    line-height: 1.6;
    color: #666;
    /* 移除固定高度限制，内容过多时自动撑开并滚动 */
    max-height: 300px;
    overflow-y: auto;
    scrollbar-width: thin;
    margin: 0;
    padding: 0;
    /* 强制自动换行，长文本不溢出 */
    word-wrap: break-word;
    word-break: normal;
    white-space: normal;
}

/* 左侧内容：右对齐，紧贴三角形左框 */
.left-section {
    text-align: right;
}

/* 右侧内容：左对齐，紧贴三角形右框 */
.right-section {
    text-align: left;
}

/* 底部内容：宽度适配，在三角形正下方居中 */
.bottom-section {
    width: 300px; /* 与左右内容宽度一致 */
    margin: 0 auto;
    text-align: center;
    /* 与三角形底部保持间距 */
    margin-top: 10px;
}

/* 下方富文本内容：独立区域，避免重叠 */
.bottom-rich-content {
    width: 100%;
    max-width: 1200px;
    margin: 20px auto 0;
    padding: 10px 0;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
}

.bottom-rich-content p {
    margin: 0 0 16px 0;
}

.bottom-rich-content p:last-child {
    margin-bottom: 0;
}

/* 响应式调整：小屏纵向排列，内容宽度自适应 */
@media (max-width: 900px) {
    .triangle-container {
        /* 小屏纵向排列，取消最小宽度限制 */
        min-width: auto;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    .triangle-section {
        width: 100%;
        max-width: 300px;
        text-align: center;
        align-self: center;
    }

    .left-section, .right-section {
        text-align: center;
    }

    .middle-container {
        order: -1; /* 三角形在最上方 */
    }

    .bottom-section {
        margin-top: 0;
    }

    .bottom-rich-content {
        margin-top: 10px;
    }
    .top-margin {
        height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    }
}
.top-margin {
    height: 5vh; /* 底部余量占视口高度的25%（可调整，如30vh） */
    clear: both;
}
</style>